/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInWatchTrendPoint
 */
export interface DropInWatchTrendPoint {
    /**
     * ISO date in UTC (YYYY-MM-DD)
     * @type {string}
     * @memberof DropInWatchTrendPoint
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchTrendPoint
     */
    sessions: number;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchTrendPoint
     */
    totalHours: number;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchTrendPoint
     */
    uniqueViewers: number;
}

/**
 * Check if a given object implements the DropInWatchTrendPoint interface.
 */
export function instanceOfDropInWatchTrendPoint(value: object): value is DropInWatchTrendPoint {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('sessions' in value) || value['sessions'] === undefined) return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined) return false;
    if (!('uniqueViewers' in value) || value['uniqueViewers'] === undefined) return false;
    return true;
}

export function DropInWatchTrendPointFromJSON(json: any): DropInWatchTrendPoint {
    return DropInWatchTrendPointFromJSONTyped(json, false);
}

export function DropInWatchTrendPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInWatchTrendPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'sessions': json['sessions'],
        'totalHours': json['totalHours'],
        'uniqueViewers': json['uniqueViewers'],
    };
}

export function DropInWatchTrendPointToJSON(json: any): DropInWatchTrendPoint {
    return DropInWatchTrendPointToJSONTyped(json, false);
}

export function DropInWatchTrendPointToJSONTyped(value?: DropInWatchTrendPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'sessions': value['sessions'],
        'totalHours': value['totalHours'],
        'uniqueViewers': value['uniqueViewers'],
    };
}

